import Cue_listing from "./cue_listing";
import Drawer from 'react-modern-drawer';
import { useEffect, useState } from "react";
import ExistingSong from "../Song/ExistingSong";
import metaDataServices from "../MetaDataServices";
import { ContactFormSearch } from "components/Contacts/contactFormSearch";

export default function CueSongUpsert(param: any) {

    let [cueSelect, setcueSelect] = useState(false);
    let [isOpen, setIsOpen] = useState(param.cueOpen);
    let [cueUpsertData, SetcuelUpsertData] = useState<any>([]);
    let [openSongListing, setOpenSongListing] = useState(false);
    let [dialogueAddOpenView, setdialogueAddOpenView] = useState(false);
    let [UsedialogueAddOpenView, setUsedialogueAddOpenView] = useState(false);
    let [showCueSuccessSaveMsg, setshowCueSuccessSaveMsg] = useState(false);

    const onCloseDrawer = () => {
        param.onChange();
        isOpen = false;
        setIsOpen(isOpen)
    }

    useEffect(() => {
        cueUpsertData = param.cueUpsert
        SetcuelUpsertData(cueUpsertData)
        console.log(cueUpsertData)
    }, [param])

    const resetCueUpsertForm = () => {
        cueUpsertData = [];
        SetcuelUpsertData(cueUpsertData)
    }

    const saveCueUpsertForm = () => {

        console.log(cueUpsertData)
        metaDataServices.cueSongsSave(cueUpsertData).then((res:any) => {
            setshowCueSuccessSaveMsg(true)
            setTimeout(function () {
                setshowCueSuccessSaveMsg(false);
            }, 3000);
        })

    }

    const closeSongListing = (e: any) => {
        console.log(e)
        openSongListing = false;
        setOpenSongListing(openSongListing);

        SetcuelUpsertData({ ...cueUpsertData, songTitle: e?.songName??"", songId: e?.songID??"", })
    }

    const onChangeSyncLicensor = (e: any) => {
        console.log(e)
        //cueUpsertData?.syncLicensor 
        setdialogueAddOpenView(dialogueAddOpenView)
        SetcuelUpsertData({ ...cueUpsertData, syncLicensor: e?.kontactDisplay??"", })
    }

    const onChangeUseLicensor = (e: any) => {
        console.log(e)
        setUsedialogueAddOpenView(UsedialogueAddOpenView)
        SetcuelUpsertData({ ...cueUpsertData, masterUseLicensor: e?.kontactDisplay??"", })
    }

    const cueSelection = (e: any) => {
        console.log(e)
        cueSelect = false
        setcueSelect(cueSelect) 

        if (e && e.masterCue) {
            SetcuelUpsertData({ ...cueUpsertData, masterCue: e?.masterCue?? "", })
        }

    }

    return (<>
        <Drawer open={isOpen}
            onClose={() => setIsOpen(false)}
            direction='right'
            className='react-drawer  allowHscroll allowVscroll'
            size={800}>
            <div className="box noBorderRadius noBorder ws-6 pull-right">

                <div className="box-header  noBorderRadius bg-blue pLarge">Add/Edit Cue Songs </div>

                <div className="ws-12 pm ">

                    {showCueSuccessSaveMsg && <div className="alert alert-success">Cue saved successfully  </div>}

                    <div className="ws-12">

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Song ID</label>
                            <input className="form-control w-61" id="songId" name="songId" type="text" placeholder="Song ID" disabled={true} value={cueUpsertData?.songId ?? ""} />
                            <button type="button" className="icon-btn info pull-right pbl" onClick={() => setOpenSongListing(true)}>Choose a Song</button>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Song Title</label>
                            <input className="ws-12" id="songTitle" name="songTitle" type="text" placeholder="Song Title" value={cueUpsertData?.songTitle ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, songTitle: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Link Id</label>
                            <input className="ws-12" id="cueLinkId" name="cueLinkId" type="text" placeholder="Cue Link Id" value={cueUpsertData?.cueLinkId ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueLinkId: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Sequence</label>
                            <input className="ws-12" id="cueSequence" name="cueSequence" type="text" placeholder="Cue Sequence" value={cueUpsertData?.cueSequence ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueSequence: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Number</label>
                            <input className="form-control w-80" id="cueNumber" name="cueNumber" type="text" placeholder="Cue Number" value={cueUpsertData?.cueNumber ?? ""} disabled={true} />
                            <button className="icon-btn info height30 width90 pull-right" onClick={() => { setcueSelect(true) }}>Cue</button>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Theme</label>
                            <input className="ws-12" id="cueTheme" name="cueTheme" type="text" placeholder="Cue Theme" value={cueUpsertData?.cueTheme ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueTheme: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Public Domain Indicator</label>
                            <label className="inline ws-4">Y <input type="radio" name="publicDomainIndicator" value="Yes" checked={cueUpsertData?.publicDomainIndicator == "Yes"} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, publicDomainIndicator: e.target.value, })} /></label>
                            <label className="inline ws-4">N <input type="radio" name="publicDomainIndicator" value="No" checked={cueUpsertData?.publicDomainIndicator == "No"} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, publicDomainIndicator: e.target.value, })} /></label>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Public Domain Territory</label>
                            <label className="inline ws-4">Y <input type="radio" name="publicDomainTerritory" value="Yes" checked={cueUpsertData?.publicDomainTerritory == "Yes"} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, publicDomainTerritory: e.target.value, })} /></label>
                            <label className="inline ws-4">N <input type="radio" name="publicDomainTerritory" value="No" checked={cueUpsertData?.publicDomainTerritory == "No"} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, publicDomainTerritory: e.target.value, })} /></label>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Interested Party Id</label>
                            <input className="ws-12" id="interestedPartyId" name="interestedPartyId" type="text" placeholder="Interested Party Id" value={cueUpsertData?.interestedPartyId ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, interestedPartyId: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">IP First Name</label>
                            <input className="ws-12" id="iPfirstName" name="iPfirstName" type="text" placeholder="IP First Name" value={cueUpsertData?.iPfirstName ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, iPfirstName: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">IP Last Name</label>
                            <input className="ws-12" id="iPlastName" name="iPlastName" type="text" placeholder="IP Last Name" value={cueUpsertData?.iPlastName ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, iPlastName: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Duration</label>
                            <input className="form-control w-49 mr text-right" id="cueDurationMinute" name="cueDurationMinute" type="text" placeholder="Minutes" value={cueUpsertData?.cueDurationMinute ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueDurationMinute: e.target.value, })} />
                            <input className="form-control w-49 text-right" id="cueDurationSecond" name="cueDurationSecond" type="text" placeholder="Seconds" value={cueUpsertData?.cueDurationSecond ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueDurationSecond: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Usage</label>
                            <input className="ws-12" id="cueUsage" name="cueUsage" type="text" placeholder="Cue Usage" value={cueUpsertData?.cueUsage ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueUsage: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Sub Usage</label>
                            <input className="ws-12" id="cueSubUsage" name="cueSubUsage" type="text" placeholder="Cue Sub Usage" value={cueUpsertData?.cueSubUsage ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueSubUsage: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Role</label>
                            <input className="ws-12" id="iProle" name="iProle" type="text" placeholder="Role" value={cueUpsertData?.iProle ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, iProle: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Affiliation</label>
                            <input className="ws-12" id="iPaffiliation" name="iPaffiliation" type="text" placeholder="Affiliation" value={cueUpsertData?.iPaffiliation ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, iPaffiliation: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Share Percent</label>
                            <input className="ws-12" id="cueSharePercent" name="cueSharePercent" type="text" placeholder="Cue Share Percent" value={cueUpsertData?.cueSharePercent ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, cueSharePercent: e.target.value, })} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Sync Licensor</label>
                            <input className="form-control w-81" id="syncLicensor" name="syncLicensor" type="text" placeholder="Sync Licensor" disabled={true} value={cueUpsertData?.syncLicensor ?? ""} />
                            <ContactFormSearch onChange={onChangeSyncLicensor} data={""} open={dialogueAddOpenView} />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Master Use Licensor</label>
                            <input className="form-control w-81" id="masterUseLicensor" name="masterUseLicensor" type="text" disabled={true} placeholder="Master Use Licensor" value={cueUpsertData?.masterUseLicensor ?? ""} />
                            <ContactFormSearch onChange={onChangeUseLicensor} data={""} open={UsedialogueAddOpenView} />
                        </div>
                    </div>

                </div>

                <div className="ws-12 pm ">
                    <button type="button" className="icon-btn delete pull-right" onClick={() => onCloseDrawer()}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={() => resetCueUpsertForm()}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={() => saveCueUpsertForm()}>✔ Save</button>
                </div>
            </div>

            {
                (() => {
                    if (openSongListing) {
                        return <ExistingSong closeSongListing={closeSongListing} SongListingOpen={openSongListing} />
                    }
                    if (cueSelect) {
                        return <Cue_listing onChange={cueSelection} productSelect={cueSelect} />
                    }
                })()
            }
        </Drawer>
    </>)
}